/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendGetProjectDto } from '../models/backend-get-project-dto';
import { BackendIdDto } from '../models/backend-id-dto';
import { BackendPaginatedGetProjectListDto } from '../models/backend-paginated-get-project-list-dto';
import { BackendProjectDto } from '../models/backend-project-dto';
import { BackendProjectInfoDto } from '../models/backend-project-info-dto';
import { BackendProjectLogoDto } from '../models/backend-project-logo-dto';
import { projectsProjectCopyCreate } from '../fn/projects/projects-project-copy-create';
import { projectsProjectCopyCreate$FormData } from '../fn/projects/projects-project-copy-create-form-data';
import { ProjectsProjectCopyCreate$FormData$Params } from '../fn/projects/projects-project-copy-create-form-data';
import { ProjectsProjectCopyCreate$Params } from '../fn/projects/projects-project-copy-create';
import { projectsProjectCopyCreate$XWwwFormUrlencoded } from '../fn/projects/projects-project-copy-create-x-www-form-urlencoded';
import { ProjectsProjectCopyCreate$XWwwFormUrlencoded$Params } from '../fn/projects/projects-project-copy-create-x-www-form-urlencoded';
import { projectsProjectsCreate } from '../fn/projects/projects-projects-create';
import { projectsProjectsCreate$FormData } from '../fn/projects/projects-projects-create-form-data';
import { ProjectsProjectsCreate$FormData$Params } from '../fn/projects/projects-projects-create-form-data';
import { ProjectsProjectsCreate$Params } from '../fn/projects/projects-projects-create';
import { projectsProjectsCreate$XWwwFormUrlencoded } from '../fn/projects/projects-projects-create-x-www-form-urlencoded';
import { ProjectsProjectsCreate$XWwwFormUrlencoded$Params } from '../fn/projects/projects-projects-create-x-www-form-urlencoded';
import { projectsProjectsDestroy } from '../fn/projects/projects-projects-destroy';
import { ProjectsProjectsDestroy$Params } from '../fn/projects/projects-projects-destroy';
import { projectsProjectsInfoRetrieve } from '../fn/projects/projects-projects-info-retrieve';
import { ProjectsProjectsInfoRetrieve$Params } from '../fn/projects/projects-projects-info-retrieve';
import { projectsProjectsList } from '../fn/projects/projects-projects-list';
import { ProjectsProjectsList$Params } from '../fn/projects/projects-projects-list';
import { projectsProjectsLogoUpdateDestroy } from '../fn/projects/projects-projects-logo-update-destroy';
import { ProjectsProjectsLogoUpdateDestroy$Params } from '../fn/projects/projects-projects-logo-update-destroy';
import { projectsProjectsLogoUpdateUpdate } from '../fn/projects/projects-projects-logo-update-update';
import { ProjectsProjectsLogoUpdateUpdate$Params } from '../fn/projects/projects-projects-logo-update-update';
import { projectsProjectsPartialUpdate } from '../fn/projects/projects-projects-partial-update';
import { projectsProjectsPartialUpdate$FormData } from '../fn/projects/projects-projects-partial-update-form-data';
import { ProjectsProjectsPartialUpdate$FormData$Params } from '../fn/projects/projects-projects-partial-update-form-data';
import { ProjectsProjectsPartialUpdate$Params } from '../fn/projects/projects-projects-partial-update';
import { projectsProjectsPartialUpdate$XWwwFormUrlencoded } from '../fn/projects/projects-projects-partial-update-x-www-form-urlencoded';
import { ProjectsProjectsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/projects/projects-projects-partial-update-x-www-form-urlencoded';
import { projectsProjectsRetrieve } from '../fn/projects/projects-projects-retrieve';
import { ProjectsProjectsRetrieve$Params } from '../fn/projects/projects-projects-retrieve';
import { projectsProjectsUpdate } from '../fn/projects/projects-projects-update';
import { projectsProjectsUpdate$FormData } from '../fn/projects/projects-projects-update-form-data';
import { ProjectsProjectsUpdate$FormData$Params } from '../fn/projects/projects-projects-update-form-data';
import { ProjectsProjectsUpdate$Params } from '../fn/projects/projects-projects-update';
import { projectsProjectsUpdate$XWwwFormUrlencoded } from '../fn/projects/projects-projects-update-x-www-form-urlencoded';
import { ProjectsProjectsUpdate$XWwwFormUrlencoded$Params } from '../fn/projects/projects-projects-update-x-www-form-urlencoded';
import { projectsUnblockProjectsCreate } from '../fn/projects/projects-unblock-projects-create';
import { projectsUnblockProjectsCreate$FormData } from '../fn/projects/projects-unblock-projects-create-form-data';
import { ProjectsUnblockProjectsCreate$FormData$Params } from '../fn/projects/projects-unblock-projects-create-form-data';
import { ProjectsUnblockProjectsCreate$Params } from '../fn/projects/projects-unblock-projects-create';
import { projectsUnblockProjectsCreate$XWwwFormUrlencoded } from '../fn/projects/projects-unblock-projects-create-x-www-form-urlencoded';
import { ProjectsUnblockProjectsCreate$XWwwFormUrlencoded$Params } from '../fn/projects/projects-unblock-projects-create-x-www-form-urlencoded';

@Injectable({ providedIn: 'root' })
export class BackendApiProjectsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectsProjectCopyCreate()` */
  static readonly ProjectsProjectCopyCreatePath = '/api/projects/project/copy/{id}/';

  /**
   * Скопировать проект.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectCopyCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsProjectCopyCreate$Response(
    params: ProjectsProjectCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendGetProjectDto>> {
    return projectsProjectCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Скопировать проект.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectCopyCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsProjectCopyCreate(
    params: ProjectsProjectCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BackendGetProjectDto> {
    return this.projectsProjectCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendGetProjectDto>): BackendGetProjectDto => r.body),
    );
  }

  /**
   * Скопировать проект.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectCopyCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsProjectCopyCreate$XWwwFormUrlencoded$Response(
    params: ProjectsProjectCopyCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendGetProjectDto>> {
    return projectsProjectCopyCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Скопировать проект.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectCopyCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsProjectCopyCreate$XWwwFormUrlencoded(
    params: ProjectsProjectCopyCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendGetProjectDto> {
    return this.projectsProjectCopyCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendGetProjectDto>): BackendGetProjectDto => r.body),
    );
  }

  /**
   * Скопировать проект.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectCopyCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsProjectCopyCreate$FormData$Response(
    params: ProjectsProjectCopyCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendGetProjectDto>> {
    return projectsProjectCopyCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Скопировать проект.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectCopyCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsProjectCopyCreate$FormData(
    params: ProjectsProjectCopyCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendGetProjectDto> {
    return this.projectsProjectCopyCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendGetProjectDto>): BackendGetProjectDto => r.body),
    );
  }

  /** Path part for operation `projectsProjectsList()` */
  static readonly ProjectsProjectsListPath = '/api/projects/projects/';

  /**
   * Получение списка проектов.
   *
   * Получение списка проектов.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsProjectsList$Response(
    params?: ProjectsProjectsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendPaginatedGetProjectListDto>> {
    return projectsProjectsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Получение списка проектов.
   *
   * Получение списка проектов.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsProjectsList(
    params?: ProjectsProjectsList$Params,
    context?: HttpContext,
  ): Observable<BackendPaginatedGetProjectListDto> {
    return this.projectsProjectsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendPaginatedGetProjectListDto>): BackendPaginatedGetProjectListDto => r.body),
    );
  }

  /** Path part for operation `projectsProjectsCreate()` */
  static readonly ProjectsProjectsCreatePath = '/api/projects/projects/';

  /**
   * Создание нового проекта.
   *
   * Список и создание проектов.
   *
   * При создании проекта учитывается ограничение на создание проектов согласно тарифу пользователя.
   * В теле запроса для создания проекта можно добавить данные по конфигу проекта. Если такие данные
   * не будут предоставлены, проект будет создан без конфигурации.
   *
   * При использовании метода POST документация будет основана на сериализаторе конфига.
   *
   * Енумы для конфигов берутся из эндпоинта "api_projects_enum_choices_retrieve".
   *
   * Источники финансирования берутся из эндпоинта "api_projects_financing_sources_list".
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsProjectsCreate$Response(
    params?: ProjectsProjectsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendGetProjectDto>> {
    return projectsProjectsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Создание нового проекта.
   *
   * Список и создание проектов.
   *
   * При создании проекта учитывается ограничение на создание проектов согласно тарифу пользователя.
   * В теле запроса для создания проекта можно добавить данные по конфигу проекта. Если такие данные
   * не будут предоставлены, проект будет создан без конфигурации.
   *
   * При использовании метода POST документация будет основана на сериализаторе конфига.
   *
   * Енумы для конфигов берутся из эндпоинта "api_projects_enum_choices_retrieve".
   *
   * Источники финансирования берутся из эндпоинта "api_projects_financing_sources_list".
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsProjectsCreate(
    params?: ProjectsProjectsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendGetProjectDto> {
    return this.projectsProjectsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendGetProjectDto>): BackendGetProjectDto => r.body),
    );
  }

  /**
   * Создание нового проекта.
   *
   * Список и создание проектов.
   *
   * При создании проекта учитывается ограничение на создание проектов согласно тарифу пользователя.
   * В теле запроса для создания проекта можно добавить данные по конфигу проекта. Если такие данные
   * не будут предоставлены, проект будет создан без конфигурации.
   *
   * При использовании метода POST документация будет основана на сериализаторе конфига.
   *
   * Енумы для конфигов берутся из эндпоинта "api_projects_enum_choices_retrieve".
   *
   * Источники финансирования берутся из эндпоинта "api_projects_financing_sources_list".
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsProjectsCreate$XWwwFormUrlencoded$Response(
    params?: ProjectsProjectsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendGetProjectDto>> {
    return projectsProjectsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Создание нового проекта.
   *
   * Список и создание проектов.
   *
   * При создании проекта учитывается ограничение на создание проектов согласно тарифу пользователя.
   * В теле запроса для создания проекта можно добавить данные по конфигу проекта. Если такие данные
   * не будут предоставлены, проект будет создан без конфигурации.
   *
   * При использовании метода POST документация будет основана на сериализаторе конфига.
   *
   * Енумы для конфигов берутся из эндпоинта "api_projects_enum_choices_retrieve".
   *
   * Источники финансирования берутся из эндпоинта "api_projects_financing_sources_list".
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsProjectsCreate$XWwwFormUrlencoded(
    params?: ProjectsProjectsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendGetProjectDto> {
    return this.projectsProjectsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendGetProjectDto>): BackendGetProjectDto => r.body),
    );
  }

  /**
   * Создание нового проекта.
   *
   * Список и создание проектов.
   *
   * При создании проекта учитывается ограничение на создание проектов согласно тарифу пользователя.
   * В теле запроса для создания проекта можно добавить данные по конфигу проекта. Если такие данные
   * не будут предоставлены, проект будет создан без конфигурации.
   *
   * При использовании метода POST документация будет основана на сериализаторе конфига.
   *
   * Енумы для конфигов берутся из эндпоинта "api_projects_enum_choices_retrieve".
   *
   * Источники финансирования берутся из эндпоинта "api_projects_financing_sources_list".
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsProjectsCreate$FormData$Response(
    params?: ProjectsProjectsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendGetProjectDto>> {
    return projectsProjectsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Создание нового проекта.
   *
   * Список и создание проектов.
   *
   * При создании проекта учитывается ограничение на создание проектов согласно тарифу пользователя.
   * В теле запроса для создания проекта можно добавить данные по конфигу проекта. Если такие данные
   * не будут предоставлены, проект будет создан без конфигурации.
   *
   * При использовании метода POST документация будет основана на сериализаторе конфига.
   *
   * Енумы для конфигов берутся из эндпоинта "api_projects_enum_choices_retrieve".
   *
   * Источники финансирования берутся из эндпоинта "api_projects_financing_sources_list".
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsProjectsCreate$FormData(
    params?: ProjectsProjectsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendGetProjectDto> {
    return this.projectsProjectsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendGetProjectDto>): BackendGetProjectDto => r.body),
    );
  }

  /** Path part for operation `projectsProjectsRetrieve()` */
  static readonly ProjectsProjectsRetrievePath = '/api/projects/projects/{id}/';

  /**
   * Получить детали проекта.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsProjectsRetrieve$Response(
    params: ProjectsProjectsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectDto>> {
    return projectsProjectsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Получить детали проекта.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsProjectsRetrieve(
    params: ProjectsProjectsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendProjectDto> {
    return this.projectsProjectsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectDto>): BackendProjectDto => r.body),
    );
  }

  /** Path part for operation `projectsProjectsUpdate()` */
  static readonly ProjectsProjectsUpdatePath = '/api/projects/projects/{id}/';

  /**
   * Обновить детали проекта.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsProjectsUpdate$Response(
    params: ProjectsProjectsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectDto>> {
    return projectsProjectsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Обновить детали проекта.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsProjectsUpdate(params: ProjectsProjectsUpdate$Params, context?: HttpContext): Observable<BackendProjectDto> {
    return this.projectsProjectsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectDto>): BackendProjectDto => r.body),
    );
  }

  /**
   * Обновить детали проекта.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsProjectsUpdate$XWwwFormUrlencoded$Response(
    params: ProjectsProjectsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectDto>> {
    return projectsProjectsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Обновить детали проекта.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsProjectsUpdate$XWwwFormUrlencoded(
    params: ProjectsProjectsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendProjectDto> {
    return this.projectsProjectsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectDto>): BackendProjectDto => r.body),
    );
  }

  /**
   * Обновить детали проекта.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsProjectsUpdate$FormData$Response(
    params: ProjectsProjectsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectDto>> {
    return projectsProjectsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Обновить детали проекта.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsProjectsUpdate$FormData(
    params: ProjectsProjectsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendProjectDto> {
    return this.projectsProjectsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectDto>): BackendProjectDto => r.body),
    );
  }

  /** Path part for operation `projectsProjectsDestroy()` */
  static readonly ProjectsProjectsDestroyPath = '/api/projects/projects/{id}/';

  /**
   * Удалить проект.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsProjectsDestroy$Response(
    params: ProjectsProjectsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return projectsProjectsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Удалить проект.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsProjectsDestroy(params: ProjectsProjectsDestroy$Params, context?: HttpContext): Observable<void> {
    return this.projectsProjectsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `projectsProjectsPartialUpdate()` */
  static readonly ProjectsProjectsPartialUpdatePath = '/api/projects/projects/{id}/';

  /**
   * Частично обновить детали проекта.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsProjectsPartialUpdate$Response(
    params: ProjectsProjectsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectDto>> {
    return projectsProjectsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Частично обновить детали проекта.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsProjectsPartialUpdate(
    params: ProjectsProjectsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendProjectDto> {
    return this.projectsProjectsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectDto>): BackendProjectDto => r.body),
    );
  }

  /**
   * Частично обновить детали проекта.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsProjectsPartialUpdate$XWwwFormUrlencoded$Response(
    params: ProjectsProjectsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectDto>> {
    return projectsProjectsPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Частично обновить детали проекта.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsProjectsPartialUpdate$XWwwFormUrlencoded(
    params: ProjectsProjectsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendProjectDto> {
    return this.projectsProjectsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectDto>): BackendProjectDto => r.body),
    );
  }

  /**
   * Частично обновить детали проекта.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsProjectsPartialUpdate$FormData$Response(
    params: ProjectsProjectsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectDto>> {
    return projectsProjectsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Частично обновить детали проекта.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsProjectsPartialUpdate$FormData(
    params: ProjectsProjectsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendProjectDto> {
    return this.projectsProjectsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectDto>): BackendProjectDto => r.body),
    );
  }

  /** Path part for operation `projectsProjectsInfoRetrieve()` */
  static readonly ProjectsProjectsInfoRetrievePath = '/api/projects/projects/{id}/info/';

  /**
   * Получить информацию по проекту.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectsInfoRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsProjectsInfoRetrieve$Response(
    params: ProjectsProjectsInfoRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectInfoDto>> {
    return projectsProjectsInfoRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Получить информацию по проекту.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectsInfoRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsProjectsInfoRetrieve(
    params: ProjectsProjectsInfoRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendProjectInfoDto> {
    return this.projectsProjectsInfoRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectInfoDto>): BackendProjectInfoDto => r.body),
    );
  }

  /** Path part for operation `projectsProjectsLogoUpdateUpdate()` */
  static readonly ProjectsProjectsLogoUpdateUpdatePath = '/api/projects/projects/logo/update/{id}/';

  /**
   * Добавить лого проекта.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectsLogoUpdateUpdate()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsProjectsLogoUpdateUpdate$Response(
    params: ProjectsProjectsLogoUpdateUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectLogoDto>> {
    return projectsProjectsLogoUpdateUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Добавить лого проекта.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectsLogoUpdateUpdate$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsProjectsLogoUpdateUpdate(
    params: ProjectsProjectsLogoUpdateUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendProjectLogoDto> {
    return this.projectsProjectsLogoUpdateUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectLogoDto>): BackendProjectLogoDto => r.body),
    );
  }

  /** Path part for operation `projectsProjectsLogoUpdateDestroy()` */
  static readonly ProjectsProjectsLogoUpdateDestroyPath = '/api/projects/projects/logo/update/{id}/';

  /**
   * Удалить лого проекта.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectsLogoUpdateDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsProjectsLogoUpdateDestroy$Response(
    params: ProjectsProjectsLogoUpdateDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return projectsProjectsLogoUpdateDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Удалить лого проекта.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectsLogoUpdateDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsProjectsLogoUpdateDestroy(
    params: ProjectsProjectsLogoUpdateDestroy$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.projectsProjectsLogoUpdateDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `projectsUnblockProjectsCreate()` */
  static readonly ProjectsUnblockProjectsCreatePath = '/api/projects/unblock-projects/';

  /**
   * Разблокировать проекты.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsUnblockProjectsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsUnblockProjectsCreate$Response(
    params: ProjectsUnblockProjectsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendIdDto>> {
    return projectsUnblockProjectsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Разблокировать проекты.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsUnblockProjectsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsUnblockProjectsCreate(
    params: ProjectsUnblockProjectsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendIdDto> {
    return this.projectsUnblockProjectsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendIdDto>): BackendIdDto => r.body),
    );
  }

  /**
   * Разблокировать проекты.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsUnblockProjectsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsUnblockProjectsCreate$XWwwFormUrlencoded$Response(
    params: ProjectsUnblockProjectsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendIdDto>> {
    return projectsUnblockProjectsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Разблокировать проекты.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsUnblockProjectsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsUnblockProjectsCreate$XWwwFormUrlencoded(
    params: ProjectsUnblockProjectsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendIdDto> {
    return this.projectsUnblockProjectsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendIdDto>): BackendIdDto => r.body),
    );
  }

  /**
   * Разблокировать проекты.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsUnblockProjectsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsUnblockProjectsCreate$FormData$Response(
    params: ProjectsUnblockProjectsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendIdDto>> {
    return projectsUnblockProjectsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Разблокировать проекты.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsUnblockProjectsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsUnblockProjectsCreate$FormData(
    params: ProjectsUnblockProjectsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendIdDto> {
    return this.projectsUnblockProjectsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendIdDto>): BackendIdDto => r.body),
    );
  }
}
